<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				{{ $t("label.edit_profile") }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md4>
						<ValidationProvider
							name="first_name"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.first_name"
								:label="$t('First Name')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md4>
						<ValidationProvider
							name="middle_name"
							rules=""
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.middle_name"
								:label="$t('label.middle_name')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class=""
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md4>
						<ValidationProvider
							name="last_name"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.last_name"
								:label="$t('Last Name')"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="primary"
					@click="submit()"
					:loading="item.processing"
				>
					<v-icon left>mdi-content-save</v-icon>
					{{ $t("Submit") }}
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["customer"],
	data() {
		return {
			item: this.$inertia.form(this.customer),
		};
	},

	methods: {
		submit() {
			try {
				this.item.put(this.$route("profile.update"));
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>